export default __webpack_public_path__ + "static/media/mask1.06b76a4c.jpg";